// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

const MAX_IMAGE_BYTES = 5 * 1024 * 1024
const BLOCKED_IMAGE_TYPES = ["image/svg+xml"] // Potential embedded script

// Validate Trix file attachments before they are uploaded to Active Storage.
document.addEventListener("trix-file-accept", (event) => {
  const { file } = event

  if (!file.type.startsWith("image/") || BLOCKED_IMAGE_TYPES.includes(file.type)) {
  event.preventDefault()
  window.alert("Solo se pueden adjuntar imágenes (JPG, PNG, GIF, WEBP).")
    return
  }

  if (file.size > MAX_IMAGE_BYTES) {
    event.preventDefault() 
    window.alert("La imagen supera el tamaño máximo permitido (5MB).")
  }
})
